var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoutingDestinationMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1555_11",
    "data-name": "Component 1555 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10752",
    "data-name": "Rectangle 10752",
    width: 40,
    height: 40,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location_3_",
    "data-name": "location (3)",
    transform: "translate(-71.799 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11023",
    "data-name": "Path 11023",
    d: "M119.1,399.242c6.3,0,11.446-2.117,11.446-4.712s-5.142-4.714-11.446-4.714-11.444,2.117-11.444,4.714S112.795,399.242,119.1,399.242Z",
    transform: "translate(-27.55 -359.742)",
    fill: "#76c64f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11024",
    "data-name": "Path 11024",
    d: "M211.288,389.816c5.821,0,10.626,1.789,11.351,4.1H211.288l-3.737-3.845A26.675,26.675,0,0,1,211.288,389.816Z",
    transform: "translate(-119.741 -359.742)",
    fill: "#5fa040",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11025",
    "data-name": "Path 11025",
    d: "M91.547,34.178,81.811,24.16a14.5,14.5,0,0,1,0-20.027,13.525,13.525,0,0,1,19.46,0l.007.009a14.5,14.5,0,0,1,0,20.027Z",
    transform: "translate(0 0)",
    fill: "red",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11026",
    "data-name": "Path 11026",
    d: "M166.259,98.478a7.084,7.084,0,1,1,10.018,0A7.084,7.084,0,0,1,166.259,98.478Z",
    transform: "translate(-79.72 -79.721)",
    fill: "#eaf2ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11027",
    "data-name": "Path 11027",
    d: "M243.706,86.457a7.083,7.083,0,1,1,0,14.039,7.083,7.083,0,0,0,0-14.039Z",
    transform: "translate(-153.107 -79.728)",
    fill: "#c9e0fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11028",
    "data-name": "Path 11028",
    d: "M251.654,4.145a14.5,14.5,0,0,1,0,20.027l-5.807,5.976-2.916,3,1.008,1.038,3.739-3.845,5.995-6.168a14.5,14.5,0,0,0,0-20.027l-.007-.009A13.511,13.511,0,0,0,242.93.045a13.524,13.524,0,0,1,8.717,4.09Z",
    transform: "translate(-152.389 -0.007)",
    fill: "#bd161d",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutingDestinationMarker);
export default __webpack_public_path__ + "static/media/routing-destination-marker.55480ba27ba68152ac497160ff138823.svg";
export { ForwardRef as ReactComponent };